import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';

export const AddressCodec = t.intersection([
    t.type({
        name: t.string,
        street: t.string,
        postal_code: t.string,
        city: t.string,
        country_code: t.string,
    }),
    t.partial({
        additional_name_information: t.string,
        additional_street_information: t.string,
    }),
]);
export type ApiAddress = t.TypeOf<typeof AddressCodec>;

export const OptionalAddressCodec = t.partial({
    name: NonEmptyString,
    street: NonEmptyString,
    additional_name_information: NonEmptyString,
    additional_street_information: NonEmptyString,
    postal_code: NonEmptyString,
    city: NonEmptyString,
    country_code: NonEmptyString,
});

export type ApiOptionalAddress = t.TypeOf<typeof OptionalAddressCodec>;
